import { z } from 'zod'

export const COACHING_SHELL_SETTINGS_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellSettingsResponseSchema = z.unknown()
export type CoachingShellSettingsResponse = z.infer<typeof coachingShellSettingsResponseSchema>
